import { useIsWorkflowsInCircleEnabled } from "@/react/components/SettingsApp/Workflows/hooks/useIsWorkflowsInCircleEnabled";
import { createWorkflowsPaths } from "./workflows";

export const useWorkflowsPaths = () => {
  const isWorkflowsInCircleEnabled = useIsWorkflowsInCircleEnabled();
  return createWorkflowsPaths(isWorkflowsInCircleEnabled);
};
